module.exports = __webpack_public_path__ + "static/media/WalletIcon.27f979ac.svg";